import * as React from "react";
import { createStyles, makeStyles } from "@material-ui/styles";

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    RelodeTheme,
    Text,
} from "../";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                minWidth: 640,
            },
            dialogTitle: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            },
            dialogActions: {
                justifyContent: "center",
                marginBottom: theme.spacing(2),
            },
            icon: {
                marginRight: theme.spacing(1),
            },
            infoText: {
                color: theme.relode.colors.pageSecondaryColor,
            },
        }),
    { name: "AppVersionCheckerDialog" }
);

interface AppVersionCheckerDialogProps {
    open: boolean;
    onRefresh: () => void;
    appName: string;
}

export const AppVersionCheckerDialog = (
    props: AppVersionCheckerDialogProps
) => {
    const classes = useStyles(props);
    const { appName } = props;

    return (
        <Dialog open={props.open}>
            <DialogTitle title="update available" />
            <DialogContent>
                <Text variant="body1" className={classes.infoText}>
                    Good news! A new version {!!appName ? `of ${appName} ` : ""}
                    is available. Please click below to load this update.
                </Text>
            </DialogContent>
            <DialogActions
                submit={{
                    label: "update now",
                    onSubmit: props.onRefresh,
                }}
            />
        </Dialog>
    );
};
